export type EditorVersionLinkProps = {
   label: string;
   url: string;
};

/**
 * Both the wording and the target come from PHP: which of the two links to
 * render depends on the flag's value with no override applied, and only the
 * server has resolved GrowthBook by then. See iFixit\Guide\View\EditorVersionLink.
 *
 * A full page load is the point. The flag picks the renderer server-side, so
 * the new editor can only arrive as a fresh document.
 */
export function EditorVersionLink({ link }: { link?: EditorVersionLinkProps | null }) {
   if (!link) {
      return null;
   }

   return (
      <a
         href={link.url}
         className="shrink-0 whitespace-nowrap text-sm font-medium text-primary underline-offset-2 hover:text-brand-600 dark:hover:text-primary hover:underline"
      >
         {link.label}
      </a>
   );
}
